export default __webpack_public_path__ + "5ec3e6bd1cac92005e5667fbac8a83ae.png";